import React from "react";
import {
  Box,
  Button,
} from '@mui/material';
import ActionFooter from "../../../../../Shared/ActionFooter/ActionFooter";

const StepperNative = (props: any) => {
  const {
    photos,
    atualItem,
    handleNext,
    changeIndex,
    skipTutorial,
    photo,
  } = props;

  const btnText: string = (atualItem === 2) ? 'Fazer login' : 'Próximo';

  return (
    <>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '50px',
          padding: '30px 70px',
        }}
      >
        <img src={photo} alt="tutorial-example" />
        <div className="stepper-wrapper" data-testid='stepper-wrapper'>
          {photos && photos.map((photo: string, index: number) => {
            return (
              <div
                data-testid={`stepper-${index} ${(atualItem === index) ? 'active' : ''}`}
                className={`stepper ${(atualItem === index) ? 'active' : ''}`}
                onClick={() => { changeIndex(index) }}
                key={index}
              ></div>
            )
          })}
        </div>
      </Box>
      <ActionFooter>
        <Button
          fullWidth
          className="black-button"
          onClick={() => { handleNext() }}
          data-testid='text-button'
        >{btnText}</Button>
        <Button
          fullWidth
          variant="outlined"
          className="link-button"
          onClick={() => { skipTutorial() }}
          data-testid='skip-button'
        >Pular</Button>
      </ActionFooter>
    </>
  );
}

export default StepperNative;
